import { Controller } from "@hotwired/stimulus";

// Preline's HSSelect fills [data-description] slots via element.append(string),
// which creates plain text nodes — HTML tags appear literally. This controller
// watches for HSSelect building those nodes (via MutationObserver) and converts
// them to innerHTML so that <strong> and other inline tags are rendered correctly.
// Note: descriptions must only contain server-generated HTML — never user input.
export default class AdvancedSelectDescriptionsController extends Controller {
  connect() {
    // Apply immediately in case HSSelect has already built the dropdown (full page load).
    this.applyHtml();
    // Watch for HSSelect building the dropdown after Turbo navigations.
    this.observer = new MutationObserver(() => this.applyHtml());
    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  applyHtml() {
    this.element.querySelectorAll("[data-description]").forEach((el) => {
      const text = el.textContent;
      if (text && text.includes("<")) {
        el.innerHTML = text;
      }
    });
  }
}
